<div class="row">
  <div class="col">
    <div
      #maindiv
      [ngClass]="{
    'pulse ': this.speechService.isInConversationMode || this.speechService.isListening
    }"
      class="input-group input-group-prompt"
    >
      <textarea
        class="form-control"
        type="text"
        id="bot-prompt-input"
        name="bot-prompt-textarea"
        aria-label="Nachricht eingeben"
        i18n-aria-label="@@bot-prompt-input-label"
        aria-describedby="inputGroup-sizing-default"
        (keydown)="onKey($event)"
        (paste)="onPaste($event)"
        (focus)="maindiv.classList.add('glow')"
        (blur)="maindiv.classList.remove('glow')"
        [(ngModel)]="this.promptInput"
        (ngModelChange)="this.promptInputChange.emit($event)"
        [ngClass]="{'d-none': this.voiceInput() && this.attService.state.getValue() === 'listening'}"
        [ngStyle]="{ 'padding-top': botPromptInput.offsetHeight === 44 ? '9px': '6px'}"
        [placeholder]="this.isSending() ? 'Senden...' : ''"
        appTextareaAutoresize
        #botPromptInput
      ></textarea>
      <div
        class="form-control form-control-plaintext  voice-bars-holder p-0 m-0"
        [ngClass]="{'d-none': !this.voiceInput() || this.attService.state.getValue() !== 'listening'}"
      >
        <app-voice-bars></app-voice-bars>
      </div>
      @if (this.voiceInput()) {
      <span class="input-group-text p-1 ">
        <!-- BTN FÜR MIC -->
        @if (this.promptInput.length === 0 && !this.speech2.isRecording()) {
        <button
          type="button"
          [ngClass]="{ 'disabled': isThinking() || this.speechService.isInConversationMode }"
          class="btn btn-primary-outline border-opacity-10"
          id="btn-voice-input-prompt"
          aria-label="Spracheingabe starten"
          i18n-aria-label="@@bot-prompt-start-voice-input"
          (click)="startSingleRec()"
        >
          <i
            class="ri-mic-line mx-n1"
            aria-hidden="true"
          ></i>
        </button>
        }
        @if (this.speechService.isInConversationMode) {
        <button
          type="button"
          class="btn btn-danger chat-rec"
          aria-label="Sprachaufnahme beenden"
          i18n-aria-label="@@bot-prompt-stop-voice-input"
          (click)="stopChatRec(); this.playService.stopAudio();"
        >
          <i
            class="ri-close-fill"
            aria-hidden="true"
          ></i>
        </button>
        }
      </span>
      }
      <!-- 2. button spalte-->
      <span class="input-group-text p-1">
        @if (!this.cancelThinking() || (this.cancelThinking() && !this.isThinking())) {
        @if (!this.speech2.isRecording()) {
        <button
          type="button"
          [ngClass]="{'disabled':  promptInput.trim().length === 0 || this.isThinking()}"
          class="btn btn-primary"
          id="btn-send-prompt"
          aria-label="Nachricht senden"
          i18n-aria-label="@@bot-prompt-send-message"
          (click)="this.sendPrompt.emit()"
        >
          <i
            [ngClass]="{
                  'ri-arrow-up-line mx-n1': promptInput.trim().length >= 0,
                  'ri-send-plane-2-fill mx-n0': promptInput.trim().length === 0
                }"
            aria-hidden="true"
          ></i>
        </button>
        }
        }
        @if (this.cancelThinking()) {
        @if (!this.speech2.isRecording() && this.isThinking()) {
        <button
          class="stfu-button bg-danger text-white"
          id="btn-stfu"
          aria-label="Antwort abbrechen"
          i18n-aria-label="@@bot-prompt-cancel-thinking"
          (click)="this.cancelMsgThinking()"
        >
          <i
            class="ri-stop-large-fill"
            aria-hidden="true"
          ></i>
        </button>
        }
        }
        @if (!this.speechService.isInConversationMode) {
        @if (this.speechService.isListening) {
        <button
          type="button"
          class="btn btn-primary  recording"
          id="btn-stop-record"
          aria-label="Aufnahme bestätigen"
          i18n-aria-label="@@bot-prompt-confirm-recording"
          (click)="stopSingleRec()"
        >
          <i
            class="ri-check-fill mx-n1"
            aria-hidden="true"
          ></i>
        </button>
        }
        }
      </span>
    </div>
  </div>
  <!-- BUTTONS FÜR BOT MODUS WECHSEK-->
  <div
    class="col-auto p-1 align-self-end"
    id="extra-buttons-container"
  >
    @if (this.switchToChat()) {
    <button
      class="btn switchto-btn ms-2"
      id="btn-switch-to-chat"
      tooltip="Zum Chat wechseln"
      i18n-tooltip="@@switch-to-chat"
      aria-label="Zum Chat wechseln"
      i18n-aria-label="@@switch-to-chat"
    >
      <a
        href="/{{this.langService.getLanguage()}}/bot/{{this.botConfig()._id}}"
        class="text-decoration-none"
        tabindex="-1"
      >
        <i
          class="ri-chat-ai-fill"
          aria-hidden="true"
        ></i>
      </a>
    </button>
    }
    @if (this.switchToVoice()) {
    <button
      class="btn switchto-btn ms-2"
      id="btn-switch-to-voice"
      tooltip="Zu Voice wechseln"
      i18n-tooltip="@@switch-to-voice"
      aria-label="Zu Voice wechseln"
      i18n-aria-label="@@switch-to-voice"
    >
      <a
        href="/{{this.langService.getLanguage()}}/bot/{{this.botConfig()._id}}/audio"
        class="text-decoration-none"
        tabindex="-1"
      >
        <i
          class="ri-voice-ai-fill"
          aria-hidden="true"
        ></i>
      </a>
    </button>
    }
    @if (this.switchToAvatar()) {
    <button
      class="btn switchto-btn ms-2"
      id="btn-switch-to-avatar"
      tooltip="Zum Avatar wechseln"
      i18n-tooltip="@@switch-to-avatar"
      aria-label="Zum Avatar wechseln"
      i18n-aria-label="@@switch-to-avatar"
    >
      <a
        href="/{{this.langService.getLanguage()}}/bot/{{this.botConfig()._id}}/avatar"
        class="text-decoration-none"
        tabindex="-1"
      >
        <i
          class="ri-video-ai-fill"
          aria-hidden="true"
        ></i>
      </a>
    </button>
    }
  </div>
</div>